<template>
    <UButton v-bind="$attrs" :to="to" :block="block" class="cursor-pointer px-8 mt-auto font-bold py-3 transition-all border border-[#2441e7] bg-[#2441e7] text-white 
           hover:brightness-120 hover:bg-[#2441e7] 
           active:brightness-120 active:bg-[#2441e7]" :ui="{ rounded: 'rounded-md' }">
        <slot />
    </UButton>
</template>

<script setup>
defineProps({
    to: {
        type: String,
        default: undefined
    },
    block: {
        type: Boolean,
        default: false
    }
})
</script>